import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(`
  mutation deleteNoteReminder($reminderId: String!) {
    deleteNoteReminder(reminderId: $reminderId) {
      id
    }
  }
`);

type Args = VariablesOf<typeof QUERY>;

// TODO: This needs refactoring. We shouldn't be appending the companyId and noteId to the query args
// However, the legacy logic piggybacks these values in so it can invalide the cache on mutation success
type OverScopedValues = {
  companyId: string;
  noteId: string;
};

export const mutationFn = async ({ reminderId }: Args & OverScopedValues) => {
  const { deleteNoteReminder, errors } = await gqlClient.request(QUERY, {
    reminderId,
  });
  ``;
  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return deleteNoteReminder;
};
